<template>
  <v-card :loading="loading" class="form-card">
    <!-- TITLE -->
    <v-card-title v-if="config.title" class="form-card-title">
      <v-icon small left color="#00ffff">mdi-form-select</v-icon>
      {{ config.title }}
    </v-card-title>

    <v-divider v-if="config.title" class="cyan-divider" />

    <v-card-text>
      <!-- DEBUG MODE -->
      <div v-if="config.isDebug" class="debug-box">
        {{ xdataset }}
      </div>

      <!-- FORM -->
      <v-form v-model="valid">
        <v-jsf
          v-model="xdataset"
          :schema="schema"
          :options="xoptions"
          @change="onChange($event, xdataset)"
          @input="onInput"
          @message="TestMsg"
        />
      </v-form>
    </v-card-text>

    <!-- ACTION BUTTONS -->
    <v-card-actions v-if="!config.hide_actions" class="form-actions">
      <v-spacer></v-spacer>
      <v-btn outlined color="#00ffff" class="btn-outline" @click="doReset"
        >Reset
      </v-btn>
      <v-btn color="#00ffff" class="btn-filled" dark @click="doSearch">
        Search
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<style scoped>
/* CARD UTAMA */
.form-card {
  background: rgba(15, 25, 35, 0.65) !important;
  backdrop-filter: blur(12px);
  border: 1px solid rgba(0, 234, 255, 0.2);
  border-radius: 16px !important;
  box-shadow: 0 4px 20px rgba(0, 234, 255, 0.08);
  color: #e0f7fa !important;
}

.form-card:hover {
  box-shadow: 0 6px 18px rgba(0, 255, 255, 0.25);
  transform: translateY(-2px);
}

/* TITLE */
.form-card-title {
  background-color: rgba(15, 35, 70, 0.5) !important;
  border-top-left-radius: 14px;
  border-top-right-radius: 14px;
  color: #00ffff !important;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  gap: 6px;
  border-color: #00ffff;
}

/* DIVIDER */
.cyan-divider {
  border-color: #00ffff !important;
  opacity: 0.5;
}

/* DEBUG BOX */
.debug-box {
  background-color: rgba(15, 35, 70, 0.5) !important;
  border: 1px solid rgba(0, 255, 255, 0.3);
  color: #00ffff;
  border-radius: 8px;
  font-size: 13px;
  padding: 10px;
  margin-bottom: 10px;
  font-family: monospace;
  border-color: #00ffff;
}

/* FORM ELEMEN (v-jsf) */
.custom-vjsf >>> .v-input,
.custom-vjsf >>> .v-select,
.custom-vjsf >>> .v-text-field {
  background-color: rgba(255, 255, 255, 0.05) !important;
  color: #00ffff !important;
  border-radius: 8px;
  margin-bottom: 12px;
}

.custom-vjsf >>> label {
  color: #00ffff !important;
}

.custom-vjsf >>> input {
  color: #00ffff !important;
}

.custom-vjsf >>> .v-messages__message {
  color: rgba(0, 255, 255, 0.6) !important;
}

/* BUTTON AREA */
.form-actions {
  background-color: rgba(15, 35, 70, 0.5) !important;
  border-top: 1px solid rgba(0, 255, 255, 0.2);
  padding: 8px 16px;
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;
}

/* BUTTONS */
.btn-outline {
  border: 1px solid #00ffff !important;
  color: #00ffff !important;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

.btn-outline:hover {
  background-color: rgba(0, 255, 255, 0.1) !important;
}

.btn-filled {
  background-color: #00ffff !important;
  color: #1e1e2f !important;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  font-weight: 600;
  transition: all 0.25s ease;
}

.btn-filled:hover {
  background-color: #18ffff !important;
  transform: scale(1.03);
}
</style>

<script>
import VJsf from "@koumoul/vjsf/lib/VJsf.js";
import Vue from "vue";
import "@koumoul/vjsf/lib/VJsf.css";
import "@koumoul/vjsf/lib/deps/third-party.js";
import axios from "axios";
import ObjDiffMapper from "../../utils/ObjDiffMapper";
import objPath from "object-path";
// import { config } from "process";

// fungsi untuk mengubah parameter dengan kurawal, misalnya {b} menjadi nilai dari b
const replaceParam = function (str, obj) {
  var re = /{([^}]+)}/g;
  var matches = str.match(re);
  if (matches) {
    for (var i = 0; i < matches.length; i++) {
      var key = matches[i].replace("{", "").replace("}", "");
      var value = objPath.get(obj, key);
      str = str.replace(matches[i], value);
    }
  }
  return str;
};

export default {
  components: {
    VJsf,
  },
  data: function () {
    return {
      xdataset: {},
      dialog: false,
      valid: true,
      dialog_caption: "Edit Data",
      msgDialog: false,
      dialog_message: "",
      model: {},
      options: {
        httpLib: axios,
        // httpOptions: {
        //   baseURL: axios.defaults.baseURL+'/run/exec/pln-nusantara/navitas/v1/'
        // }
      },
      oldevent: {},
      schema: Vue.util.extend({}, this.config.schema),
    };
  },
  computed: {
    calcDataset() {
      return this.dataset;
    },
    router_params() {
      return this.$route.query;
    },
    xoptions: function () {
      let voptions = this.options;
      voptions.context = this.config.context;
      return voptions;
    },
  },
  watch: {
    "config.dialog"(value) {
      this.dialog = value;
    },
    dataset(value) {
      this.xdataset = value;
    },
    dialog(value) {
      if (!value) {
        this.$emit("message", this.name, "close-dialog");
      }
    },
  },
  props: {
    name: {
      type: String,
      default: function () {
        return "untitled";
      },
    },
    config: {
      type: Object,
      default: function () {
        return {};
      },
    },
    dataset: {
      type: Object,
      default: function () {
        return {};
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async lookupData(vinput, vdata, vconfig) {
      let xurl = replaceParam(vconfig.url, vdata);
      let vurl;

      // Check if it's a spju lookup, use smart-apj-api directly
      if (xurl.startsWith("spju/lookup/")) {
        vurl = axios.defaults.baseURL + xurl;
      } else {
        // For other lookups, use nocode-api
        vurl =
          axios.defaults.baseURL +
          "/run/exec/pju-tenant/pju-dashboard/v1/" +
          xurl;
      }

      console.log("vurl", vurl);
      let xdata = await axios.get(vurl);
      console.log("xdata", xdata);
      let vresult = xdata?.data;
      let result = null;
      // Support dot-path (e.g. "data.result") and multiple shapes
      try {
        const itemsPropPath = vconfig?.itemsProp || "data";
        const itemsFromPath = objPath.get(vresult, itemsPropPath);
        if (Array.isArray(itemsFromPath)) {
          result = itemsFromPath;
        } else if (Array.isArray(vresult?.result)) {
          result = vresult.result;
        } else if (Array.isArray(vresult?.data)) {
          result = vresult.data;
        }
      } catch (e) {
        // noop
      }
      return result;
    },
    closeDialog() {
      this.$emit("message", "close-dialog");
    },

    async onChange(event, doClear = true) {
      console.log("onChange-event", event);
      console.log("old event", this.oldevent);
      const diff = ObjDiffMapper(this.oldevent, event);
      // console.log('diff', diff)
      // console.log('diff-x', Object.keys(diff)[0])
      let edited_fields = Object.keys(diff);
      for (let i = 0; i < edited_fields.length; i++) {
        let edited_field = edited_fields[i];
        if (edited_field) {
          // Menambahkan logika reset cascading dropdown secara manual
          // Sesuai permintaan: jika provinsi berubah, reset kota dan kecamatan.
          if (edited_field === "provinsi") {
            console.log(
              'Provinsi changed, resetting Kota and Kecamatan to "all"'
            );
            this.xdataset.kota = "all";
            this.xdataset.kecamatan = "all";
          } else if (edited_field === "kota") {
            // Jika kota berubah, reset kecamatan saja.
            console.log('Kota changed, resetting Kecamatan to "all"');
            this.xdataset.kecamatan = "all";
          }

          if (doClear) {
            const affected_field = objPath.get(
              this.config,
              "schemaOnChange.clear." + edited_field
            );
            console.log("affected_field", affected_field);
            if (affected_field) {
              for (const el of affected_field) {
                // PERBAIKAN: Ubah 'null' menjadi 'all' sesuai permintaan
                this.xdataset[el] = "all";
              }
            }
          }
          const updated_field = objPath.get(
            this.config,
            "schemaOnChange.update." + edited_field
          );
          console.log("updated_field", updated_field);
          if (updated_field) {
            for (const el of updated_field) {
              let xfunc = el?.function;
              let xval = objPath.get(this.xdataset, el.from);
              if (xfunc === "lookup") {
                let xdata = await this.lookupData(el, this.xdataset, el.config);
                xval = xdata;
              }
              objPath.set(this.xdataset, el.to, xval);
            }
          }
          console.log("xdataset", this.xdataset);
        }
      }

      this.$emit("onchange", diff, this.xdataset);
      this.oldevent = { ...event };
      await this.updateRouter();
      // console.log('event.target.name', event.target.name)
    },

    async updateRouter() {
      // update router dari xdataset sesuai list yang ada di config.update_router
      if (this.config.update_router) {
        let update = {};
        let doUpdate = false;
        for (let i = 0; i < this.config.update_router.length; i++) {
          let xfield = this.config.update_router[i];
          let xval = objPath.get(this.xdataset, xfield);
          if (typeof xval !== "undefined" && xval !== null) {
            objPath.set(update, xfield, xval);
            doUpdate = true;
          }
        }
        console.log("update", update);
        if (doUpdate) {
          this.$router.replace({ query: update });
        }
      }
    },

    // async onChange(event, x, y, z) {
    //   console.log('onChange', event, x, y, z)
    //   console.log('old event', this.oldevent)
    //   const diff = ObjDiffMapper(this.oldevent, event)
    //   console.log('diff', diff)
    //   const affected_field = this.config.schemaOnChange.clear[Object.keys(diff)[0]]
    //   console.log('affected_field', affected_field)
    //   if (affected_field) {
    //     for (const el of affected_field) {
    //       this.schema.properties[el].items = []
    //       this.xdataset[el] = {}
    //     }
    //   }

    //   this.oldevent = {...event}
    //   // console.log('event.target.name', event.target.name)
    // },
    onInput(event, x, y, z) {
      console.log("onInput", event, x, y, z);
    },
    TestMsg(a, b, c, d) {
      console.log("TestMsg", a, b, c, d);
    },
    doSearch() {
      console.log("this.dataset", this.xdataset);
      // message, command, name, data
      // this.xdataset.do_search = 1
      this.onChange(this.xdataset, false);
      // this.$emit('message', this.name, 'search', this.xdataset)
      this.$emit("search", this.xdataset);
    },
    doReset() {
      this.xdataset = this.dataset;
      this.$emit("reset", this.xdataset);
    },
  },
  mounted() {
    this.dialog = this.config.dialog;
    let vdataset = this.dataset;
    let vroute = this.$route.query;
    this.xdataset = { ...vroute, ...vdataset };
    this.onChange(this.xdataset, false);
    if (this.xdataset?.do_search) {
      this.doSearch();
    }
    // this.oldevent = {...this.xdataset}
    // let me = this
    // setTimeout(function(){
    //   me.dialog = true
    // }, 5000)
  },
};
</script>
